import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { createIntlCache, createIntl, useIntl } from 'react-intl';

import { hideFormChoiceModal, addOnlineForm } from 'actions/form';
import ModalWrapper from 'components/Modals/ModalWrapper';
import ModalInstructions from 'components/ModalInstructions';
import MustHaveReadText from 'components/MustHaveReadText';
import { defaultLanguage } from 'common/language/localeHelper';
import { isTranslatedForm } from 'common/forms/formTypeHelper';

const FormChoiceModal = ({ formType, dispatch, selectedAccountId, locale, messages, englishMessages, availableFormTypes }) => {
  const [allRead, setAllRead] = useState(false);
  const modalInstruction = ModalInstructions(formType);

  const localeToDisplay = formType !== null && isTranslatedForm(formType)
    ? locale
    : defaultLanguage.key;
  const messagesToDisplay = localeToDisplay === defaultLanguage.key ? englishMessages : messages;
  const cache = createIntlCache();
  const intl = localeToDisplay === defaultLanguage.key ? createIntl({ locale: localeToDisplay, messages: messagesToDisplay }, cache) : useIntl();

  const formTypeInfo = availableFormTypes.find(ft => ft.formType === formType.toLowerCase());

  return (
    <ModalWrapper
      title={ modalInstruction != null && modalInstruction.FormChoiceTitle }
      closeButtonName={ modalInstruction.FormName }
      disableConfirm={ !allRead }
      content={ modalInstruction != null
      && <MustHaveReadText
        content={ modalInstruction.FormChoiceContent }
        IsTextRead={ value => setAllRead(value) }
      /> }
      btnCancelTitle={ intl.formatMessage({ id: 'formChoiceModal.buttonCancelTitle' }) }
      btnConfirmTitle={ intl.formatMessage({ id: 'formChoiceModal.buttonConfirmTitle' }) }
      footer={ !allRead ? intl.formatMessage({ id: 'formChoiceModal.NotAllRead' }) : intl.formatMessage({ id: 'formChoiceModal.AllRead' }) }
      onCancel={ () => dispatch(hideFormChoiceModal()) }
      onConfirm={ () => { dispatch(hideFormChoiceModal()); dispatch(addOnlineForm(formTypeInfo, selectedAccountId)); } }
    />);
};

FormChoiceModal.defaultProps = {
  formType: '',
  selectedAccountId: 0,
  availableFormTypes: [],
};

FormChoiceModal.propTypes = {
  formType: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  selectedAccountId: PropTypes.number,
  locale: PropTypes.string.isRequired,
  messages: PropTypes.shape({}).isRequired,
  englishMessages: PropTypes.shape({}).isRequired,
  availableFormTypes: PropTypes.arrayOf(PropTypes.shape),
};

function mapStateToProps(state) {
  const {
    app: {
      locale,
      messages,
      englishMessages,
      onlineConfig
    },
    form: {
      formType,
      isFormChoiceShown,
      selectedAccountId
    }
  } = state;

  const activeFormTypes = onlineConfig?.formTypes?.filter(x => x.isEnabled && x.isVisible) ?? [];
  const activeFormGroups = onlineConfig?.formGroups?.filter(x => x.isEnabled && x.isVisible) ?? [];
  const availableFormTypes = [...activeFormTypes, ...activeFormGroups];

  return {
    locale,
    messages,
    englishMessages,
    formType,
    isFormChoiceShown,
    selectedAccountId,
    availableFormTypes
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormChoiceModal);
